import React from 'react'
import {VerifyEmailComponent} from './component'

export const routes = [
  {
    action: () => <VerifyEmailComponent />,
    path: '/verify-email',
  },
];
